import React from "react";
import Tag from "../../../ui-components/molecules/tag/tag";
import { TagColor } from "../../../app/data/common/tagColor";

import "./pickupDetails.scss";

export type FreightItemForDisplay = {
  packageType: string;
  units?: number | null;
  yards?: number | null;
  weight?: number | null;
  length?: number | string | null;
  width?: number | string | null;
  height?: number | string | null;
  diameter?: number | string | null;
  ratingClass?: string | null;
  commodityCodeDescription?: string | null;
  notes?: string | null;
  sidemark?: string | null;
  description?: string | null;
};

type Props = {
  items: FreightItemForDisplay[];
};

export const PickupFreightItemsBlock: React.FC<Props> = ({ items }) => {
  return (
    <div className="xgs-pickup-details__items">
      {items.map((item, index) => (
        <div className="xgs-pickup-details__items__row" key={`item-${index}`}>
          <div className="xgs-pickup-details__items__row__line xgs-pickup-details__items__row__line--flex">
            <Tag
              mods={{ color: item.packageType === "ROLL" ? TagColor.BLUE : TagColor.PURPLE }}
              mix="xgs-pickup-details__package-type"
            >
              {item.packageType}
            </Tag>
            <div>
              <span>Units:</span>{" "}
              {item.units || (
                <span className="xgs-pickup-details__value--missing">missing</span>
              )}
            </div>
            {!!(item.yards && item.yards !== 0) && (
              <div>
                <span>Sq Yards:</span> {item.yards}
              </div>
            )}
            <div>
              <span>Pounds:</span>{" "}
              {item.weight || (
                <span className="xgs-pickup-details__value--missing">missing</span>
              )}
            </div>
            {!!(item.length || item.width || item.height || item.diameter) && (
              <>
                {item.packageType === "PALLET" && (
                  <div>
                    <span>Length / Width / Height:</span> {item.length || "-"} / {item.width || "-"} /{" "}
                    {item.height || "-"} in.
                  </div>
                )}

                {item.packageType === "ROLL" && (
                  <div>
                    <span>{`${item.length ? "Length / " : ""}Width / Diameter:`}</span>{" "}
                    {`${item.length} / ` || ""} {item.width || "-"} / {item.diameter || "-"} in.
                  </div>
                )}
              </>
            )}
            {item.ratingClass && (
              <div>
                <span>Class:</span> {item.ratingClass}
              </div>
            )}
            {item.commodityCodeDescription && (
              <div>
                <span>Commodity:</span> {item.commodityCodeDescription}
              </div>
            )}
          </div>
          {item.notes && (
            <div className="xgs-pickup-details__items__row__line">
              <span>Notes:</span> {item.notes}
            </div>
          )}
          {item.sidemark && (
            <div className="xgs-pickup-details__items__row__line">
              <span>Sidemark:</span> {item.sidemark}
            </div>
          )}
          {item.description && (
            <div className="xgs-pickup-details__items__row__line">
              <span>Description:</span> {item.description}
            </div>
          )}
        </div>
      ))}
    </div>
  );
};
